<template>
  <div v-if="showComponent" class="card card-material card-type">
    <div class="card-body pb-0 card-material" :class="{ 'active': isActive }">
      <div @click="openFilter()" class="card-title card-material-title" :class="{ 'clear-select': filterSecond }">
        {{ filterTitle }}
        <div v-if="filterSecond" class="badge badge-selected float-right">{{ selectedName }}</div>
        <font-awesome-icon v-if="showFilter && filterSecond" class="font-awesome-icon action angle-up hidefilter" v-on:click.stop.prevent="hideFilter" icon="angle-up"/>
      </div>

      <div v-if="showFilter" class="select-core row">
        <div v-for="filter in filters" v-bind:key="filter" v-on:click.stop.prevent="select(filter)" class="card card-select card-body col-md-6 m-md-1" :class="{ 'selected': filter === filterSecond }">
          <div class="card-core">
            {{ filter }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { SET_MATERIAL_FILTER_SECOND, SET_MATERIAL_FILTER_THIRD, SET_MATERIAL_THICKNESS, SET_MATERIAL_PRODUCT } from '../../../store/types'

  export default {
    data() {
      return {
        showFilter: false
      }
    },
    computed: {
      filters() {
        if (this.$store.getters.filterFirst) {
          let filterDeliveryProgram = this.$store.getters.filterDeliveryProgram
          let filterFirst = this.$store.getters.filterFirst

          let products = this.products.filter((product) => (product.deliveryprogram === filterDeliveryProgram && product.filter_1 === filterFirst))

          // Only get second filters
          let filters = products.map(product => product.filter_2)

          // Make sure we get the distinct filters
          filters = [...new Set(filters.sort((a, b) => a - b))]

          // If only 1 option is left, just pre-select the item, and move on
          if (filters.length === 1) {
            this.select(filters[0])
          }

          return filters
        }

        return []
      },
      products() {
        return this.$store.getters.products
      },
      filterFirst() {
        return this.$store.getters.filterFirst
      },
      filterDeliveryProgram() {
        return this.$store.getters.filterDeliveryProgram
      },
      filterSecond() {
        return this.$store.getters.filterSecond
      },
      isActive() {
        return this.showFilter || (!this.filterSecond && !this.$store.getters.filterThird)
      },
      filterTitle() {
        return this.filterFirst.indexOf('HPL') !== -1 ? 'Soort kernmateriaal' : 'Soort materiaal'
      },
      selectedName() {
        if (this.filterSecond) {
          return this.filterSecond
        }

        return ''
      },
      showComponent() {
        return this.filterDeliveryProgram && this.filters.length > 0 && this.filters[0] !== '' && this.filters[0] !== 'Meubelpanelen'
      }
    },
    methods: {
      select(select) {
        if (select !== this.filterSecond) {
          // Reset the other material filters
          this.$store.dispatch(SET_MATERIAL_FILTER_THIRD, null)
          this.$store.dispatch(SET_MATERIAL_THICKNESS, null)
          this.$store.dispatch(SET_MATERIAL_PRODUCT, null)

          this.$store.dispatch(SET_MATERIAL_FILTER_SECOND, select)
        }
        this.showFilter = false
      },
      openFilter() {
        if (this.filterSecond && this.showFilter) {
          this.showFilter = false
        } else {
          this.showFilter = true
        }
      },
      hideFilter() {
        if (this.filterSecond) {
          this.showFilter = false
        }
      }
    },
    updated() {
      this.showFilter = (this.$store.getters.loadingMaterial) ? false : (!this.filterSecond) ? true : this.showFilter
    },
    created() {
      this.showFilter = !this.filterSecond
    }
  }
</script>

<style lang="scss" scoped>
</style>
